import { render, staticRenderFns } from "./AttendanceHeaderTabs.vue?vue&type=template&id=c4f392aa"
import script from "./AttendanceHeaderTabs.vue?vue&type=script&lang=js"
export * from "./AttendanceHeaderTabs.vue?vue&type=script&lang=js"
import style0 from "./AttendanceHeaderTabs.vue?vue&type=style&index=0&id=c4f392aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTabs,QTab,QTooltip});
